/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Home_SkipInputs */

const en_gc_home_skip = /** @type {(inputs: Gc_Home_SkipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skip to content`)
};

const zh_gc_home_skip = /** @type {(inputs: Gc_Home_SkipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`跳转到正文`)
};

/**
* | output |
* | --- |
* | "Skip to content" |
*
* @param {Gc_Home_SkipInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_home_skip = /** @type {((inputs?: Gc_Home_SkipInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Home_SkipInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_home_skip(inputs)
	return zh_gc_home_skip(inputs)
});
export { gc_home_skip as "gc.home.skip" }